import { css } from 'aphrodite';
import React from 'react';
import { styleSheet } from './styles';

const GENERATING_CONTENT_MESSAGES = [
	'Good things take time… great things take a few more seconds.',
	'Just adding the final sprinkle of magic dust ✨.',
	'We’re stitching your content together — no duct tape required.',
	'Your content is stretching and warming up… almost showtime!',
	'Your content is in the oven. Smells like engagement.',
	'Sharpening pencils, aligning pixels, perfecting posts.',
	'Content this fresh needs a moment to ripen.',
	'Your brand’s voice is clearing its throat 🎤.',
	'Herding hashtags into neat little rows…',
];

const MESSAGE_ROTATION_INTERVAL = 4000;
const STAR_GENERATION_INTERVAL = 200;

export const GeneratingContentLoader = ({
	isGeneratingContent,
	className,
}: {
	isGeneratingContent: boolean;
	className?: string;
}) => {
	const ref = React.useRef<HTMLDivElement>(null);
	const [messageIndex, setMessageIndex] = React.useState(
		Math.floor(Math.random() * GENERATING_CONTENT_MESSAGES.length)
	);

	React.useEffect(() => {
		const interval = setInterval(() => {
			setMessageIndex(Math.floor(Math.random() * GENERATING_CONTENT_MESSAGES.length));
		}, MESSAGE_ROTATION_INTERVAL);
		return () => clearInterval(interval);
	}, []);

	const addStar = () => {
		if (!ref.current) {
			return;
		}
		const star = document.createElement('div');
		star.className = 'star';
		star.style.setProperty('--size', Math.random() * 10 + 3 + 'vmin');
		star.style.left = Math.floor(Math.random() * 100) + '%';
		star.style.top = Math.floor(Math.random() * 100) + '%';
		star.onanimationend = () => {
			star.remove();
		};
		ref.current.appendChild(star);
	};

	React.useEffect(() => {
		if (!isGeneratingContent) {
			return;
		}

		const interval = setInterval(() => {
			addStar();
		}, STAR_GENERATION_INTERVAL);
		return () => clearInterval(interval);
	}, [isGeneratingContent]);

	return (
		<div
			ref={ref}
			className={`${css(
				styleSheet.generatingContent,
				isGeneratingContent ? styleSheet.generatingContentActive : null
			)} ${className}`}
		>
			<p>{GENERATING_CONTENT_MESSAGES[messageIndex]}</p>
		</div>
	);
};
